import { type ReactNode } from 'react';
import { defineMessages, FormattedMessage } from 'dibs-react-intl';
import { VERTICALS } from '../constants/uriConstants.ts';
import { type VerticalType } from './SbRespL1Landing/__generated__/SbRespL1Landing_itemSearch.graphql.ts';

export const relatedCreatorsTitle = (vertical: string, creatorName: string): ReactNode => {
    if (vertical === VERTICALS.ART) {
        return (
            <FormattedMessage
                id="sb.shopRelatedArtists"
                defaultMessage="Artists Similar to {creatorName}"
                values={{ creatorName }}
            />
        );
    } else if (vertical === VERTICALS.FASHION) {
        return (
            <FormattedMessage
                id="sb.shopRelatedDesigners"
                defaultMessage="Designers Similar to {creatorName}"
                values={{ creatorName }}
            />
        );
    } else {
        return (
            <FormattedMessage
                id="sb.shopRelatedCreators"
                defaultMessage="Creators Similar to {creatorName}"
                values={{ creatorName }}
            />
        );
    }
};

export const shopAll = (shopAllTitle: string): ReactNode => (
    <FormattedMessage
        id="SbSharedRelatedCreator.shopAll"
        defaultMessage="Shop All {shopAllTitle}"
        values={{ shopAllTitle }}
    />
);

export const shopVertical: Partial<Record<VerticalType, ReactNode>> = {
    furniture: <FormattedMessage id="sb.shopFurniture" defaultMessage="Shop Furniture" />,
    art: <FormattedMessage id="sb.shopArt" defaultMessage="Shop Art" />,
    jewelry: <FormattedMessage id="abf.sb.shopJewelry" defaultMessage="Shop Jewelry" />,
    fashion: <FormattedMessage id="sb.shopFashion" defaultMessage="Shop Fashion" />,
};

export const viewMore: ReactNode = <FormattedMessage id="sb.viewMore" defaultMessage="View More" />;

export const viewLess: ReactNode = <FormattedMessage id="sb.viewLess" defaultMessage="View Less" />;

export const showResults = (count?: number | null): ReactNode => (
    <FormattedMessage
        id="sb.showResults"
        defaultMessage={
            '{count, plural, =0 {No Results Found} =1 {Show # Result} other {Show # Results}}'
        }
        values={{ count: count || 0 }}
    />
);

export const totalResultsMessage = (count: number): ReactNode => (
    <FormattedMessage
        id="sb.showResultsCount"
        defaultMessage={'{count, plural, =0 {No Results Found} =1 {# Result} other {# Results}}'}
        values={{ count }}
    />
);

export const sbMessages = defineMessages({
    search: {
        id: 'abf.search',
        defaultMessage: 'Search',
    },
    searchToFindMore: {
        id: 'abf.searchToFindMore',
        defaultMessage: 'Use search to find more',
    },
    noResultsFound: {
        id: 'abf.noResultsFound',
        defaultMessage: 'No results found',
    },
    close: {
        id: 'abf.close',
        defaultMessage: 'Close',
    },
    filters: {
        id: 'abf.filters',
        defaultMessage: 'Filters',
    },
});
